/* 布局 */
//前台
import Layout from "@views/layout";

const ebookRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "ebook",
            name: "EBOOK",
            meta: {
                title: "电子期刊管理",
                sort: 1,
            },
            component: () => import("@views/business/ebook/index.vue"),
            redirect: {
                name: "EBOOK_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EBOOK_LIST",
                    meta: {
                        title: "电子期刊管理",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/ebook/list.vue"),
                },
                {
                    path: "add",
                    name: "EBOOK_ADD",
                    meta: {
                        title: "新增专刊",
                        parentPath: '/business/ebook/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebook/form.vue"),
                },
                {
                    path: "add2",
                    name: "EBOOK_ADD2",
                    meta: {
                        title: "新增研究报告",
                        parentPath: '/business/ebook/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebook/form2.vue"),
                },
                {
                    path: "edit",
                    name: "EBOOK_EDIT",
                    meta: {
                        title: "编辑专刊",
                        parentPath: '/business/ebook/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebook/form.vue"),
                },
                {
                    path: "edit2",
                    name: "EBOOK_EDIT2",
                    meta: {
                        title: "编辑研究报告",
                        parentPath: '/business/ebook/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebook/form2.vue"),
                },
            ],
        },


    ],
};

export default ebookRouter;
